import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import remove from 'lodash/remove';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import Handlebars from 'handlebars';

export const sortModulesByDisplayOrder = (config = []) =>
  config.sort((a, b) => a?.displayOrder - b?.displayOrder);

export const removeCommonPath = (publicPath, url) => {
  const publicPathArray = publicPath
    .split('/')
    .filter(element => element !== '');
  const urlArray = url.split('/').filter(element => element !== '');
  const uniquePart = remove(urlArray, path => !publicPathArray.includes(path));
  return `/${uniquePart.join('/')}`;
};

export const validateDisabledConfig = (disabledConfig = {}) => {
  const {
    hoverHeadingLabel,
    hoverHeadingText,
    hoverDescriptionLabel,
    hoverDescriptionText,
    hoverCTADisplayLabel,
    hoverCTADisplayName,
    hoverCTAAction,
  } = disabledConfig;
  if (
    (hoverHeadingLabel || hoverHeadingText) ||
    (hoverDescriptionLabel || hoverDescriptionText) ||
    ((hoverCTADisplayLabel || hoverCTADisplayName) && hoverCTAAction)
  ) {
    return true;
  }
  return false;
};

export const reducerActions = {
  sortedConfig: 'sortedConfig',
  switcherClicked: 'switcherClicked',
  selectedL1Module: 'selectedL1Module',
  selectedL2Module: 'selectedL2Module',
  hoveredL1Module: 'hoveredL1Module',
  hoveredL2Module: 'hoveredL2Module',
  hoveredCollapsibleItem: 'hoveredCollapsibleItem',
  switcherHovered: 'switcherHovered',
};

export const reducer = (state, action) => {
  return { ...state, [action.type]: action.value };
};

export const initialState = {
  switcherClicked: true,
  switcherHovered: false,
  selectedL1Module: undefined,
  selectedL2Module: undefined,
  sortedConfig: [],
  hoveredL1Module: {},
  hoveredL2Module: '',
  hoveredCollapsibleItem: '',
};

export const ChevronLeftIcon = styled.img`
  height: 16px;
  width: 16px;
  transform: ${props =>
    !props.switcherClicked ? 'rotate(180deg)' : 'none !important'};
`;

export const CollapsibleNavDiv = styled.div`
  height: 100%;
  position: fixed;
  left: 0;
  z-index: 100;
  background: #04265e;
  box-shadow: 2px 0 5px -2px rgba(9, 30, 66, 0.25);
  height: 100vh;
  width: ${props => (!props.switcherClicked ? '72px' : '272px')};
  top: 0;
`;

export const SwitcherContainerDiv = styled.div`
  position: absolute;
  left: ${props => (props.switcherClicked ? '262px' : '60px')};
  top: 1.143rem;
  cursor: pointer;
  z-index: 10003;
  transition: left 0.2s ease-in-out;
`;

export const SwitcherDiv = styled.div`
  padding: ${props => (props.switcherClicked ? '0 !important' : '0 1px')};
`;
// adding arrow positon dynamically from l1Module position
export const ArrowedDiv = styled.div`
  position: absolute;
  background: #05255C;
  padding: 4px;
  clip-path: polygon(100% 0%, 20% 50%, 100% 100%);
  width: 16px; 
  height: 20px; 
  top: ${props => (`${((props?.moduleIndex+1)*60)+10}px`)};
  left: -2px;
`;

export const SingleRecordItemDiv = styled.div`
  display: inline-block;
  width: ${props => (props.disabled ? 138 : 150)}px;
  white-space: noWrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FormattedMessageWrapper = ({ id, message }) => {
  return <FormattedMessage id={id || ' '} defaultMessage={message} />;
};

export const productLogoVctr = {
  engage: require('./assets/Engage+.avif'),
  cdp: require('./assets/CDP+.avif'),
  insights: require('./assets/Insights+.avif'),
  loyalty: require('./assets/Loyalty+.avif'),
  rewards: require('./assets/Rewards+.avif'),
}

const extractDynamicValues = (inputString) => {
  const pattern = /{{(.*?)}}/g;
  return (inputString.match(pattern) || []).map(match => match.slice(2, -2));
};

const matchAndExtractMappedValue = ({ currentDomainBlockNo = -1, mappings = {} }) => {
  const replacerValue = window.location.host.split('.')?.[currentDomainBlockNo - 1];
  if (!isEmpty(replacerValue) && mappings.hasOwnProperty(replacerValue)) {
    return mappings[replacerValue];
  }
  return '';
}
export const getDifferentDomainUrl = ({ domainPattern, patternMapper }) => {
  const dynamicValues = extractDynamicValues(domainPattern);
  let domainPatternClone = domainPattern;
  dynamicValues?.map(dVal => {
    if (!isEmpty(patternMapper[dVal])) {
      const extractMapperValue = matchAndExtractMappedValue(patternMapper[dVal]);
      domainPatternClone = domainPatternClone.replace(`{{${dVal}}}`, extractMapperValue);
    }
  });
  return domainPatternClone;
};

export const loadItem = key => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};


export const saveItem = (key, value) => {
  try {
    const serializedState = JSON.stringify(value);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    // Ignoring write error as of now
  }
};

export const convertToNestedObject = (flatObject) => {
  const nestedObject = {};
  Object.entries(flatObject).forEach(([key, value]) => {
      const parts = key.split('.');
      let current = nestedObject;
      parts.forEach((part, index) => {
          if (index === parts.length - 1) {
              current[part] = value;
          } else {
              current = current[part] = current[part] || {};
          }
      });
  });
  return nestedObject;
}

export const getBreadcrumbs = (currentState, formatMessage) => {
  const defaultBreadcrumbsTemplate = "{{selectedL1Module.productPackageLabel}}: {{selectedL1Module.displayLabel}} / {{selectedL2Module.displayLabel}}";
  const breadcrumbsTemplate = currentState.selectedL2Module?.breadcrumbsTemplate || currentState.selectedL1Module?.breadcrumbsTemplate || defaultBreadcrumbsTemplate;
  const regex = /{{\s*([^{}]+?)\s*}}/g;

  let resultsObject = [...breadcrumbsTemplate?.matchAll(regex)].reduce((acc, match) => {
      acc[match[1]] = formatMessage({ id: get(currentState, match[1], match[1]) });
      return acc;
  }, {});

  const breadcrumbsTemplateCompiler = Handlebars.compile(breadcrumbsTemplate, { noEscape: true });
  const result = breadcrumbsTemplateCompiler(convertToNestedObject(resultsObject));
  return result;
};

